/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
	Box,
	Button,
	Flex,
	Image,
	Input,
	InputGroup,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Table,
	TableContainer,
	Tbody,
	Td,
	Text,
	Tfoot,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import Placeholder from '../../../assets/images/logo-placeholder.png';
import c from '../../../constant';
import useStore from '../../../store';
import { CompanyBadge } from '../../Other';
import LoadingTable from '../../Table/Loading';

const Q_COMPANIES = gql`
	query get($pagerInput: PagerInput!, $companyTypes: [InsuranceInstitutionsType!] = [], $companyName: String) {
		getCompaniesByCompanyTypes(pagerInput: $pagerInput, companyTypes: $companyTypes, companyName: $companyName) {
			companies {
				id
				name
				nameKhmer
				logo
				url
				type
				latestUpdateBranchAt
			}
			totalPages
			totalRows
		}
	}
`;

export default function CompanyPickerModal({ companyTypes = [], types = [], isOpen = false, onClose = () => null, onCallback = () => null }) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const [page, setPage] = useState(1);
	const [companyName, setCompanyName] = useState('');
	const [fetchData, { data, loading }] = useLazyQuery(Q_COMPANIES);

	useEffect(load, [companyTypes, page]);

	function load() {
		const limit = 5;
		const offset = page ? (page - 1) * limit : 0;
		const pagerInput = { limit, offset };
		const variables = { pagerInput, companyTypes: companyTypes?.length === 0 ? types : companyTypes, companyName };
		fetchData({ variables });
	}

	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} size="3xl">
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader>{t('Company List')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<InputGroup size="md">
							<Input
								onKeyDown={(e) => {
									if (e?.key === 'Enter') {
										setPage(1);
										load();
									}
								}}
								mr={2}
								w="100%"
								pr="4.5rem"
								placeholder={t('Name')}
								autoFocus
								value={companyName}
								onChange={(e) => setCompanyName(e.target.value)}
							/>
							<Button
								borderRadius={c.borderRadius}
								size="md"
								onClick={() => {
									setPage(1);
									load();
								}}
							>
								{t('Search')}
							</Button>
						</InputGroup>
						<Box p={4}>
							<TableContainer>
								<Table variant="simple">
									<Thead>
										<Tr>
											<Th>{t('Logo')}</Th>
											<Th>{t('Company Name')}</Th>
											<Th isNumeric>{t('Company Type')}</Th>
										</Tr>
									</Thead>
									<Tbody>
										{loading && <LoadingTable column={3} />}
										{data?.getCompaniesByCompanyTypes?.companies.length <= 0 && (
											<Tr>
												<Td colSpan={3}>
													<Text>{t('No Data')}</Text>
												</Td>
											</Tr>
										)}
										{data?.getCompaniesByCompanyTypes?.companies?.map((e, i) => {
											return (
												<Tr
													_hover={{ backgroundColor: 'gray.200' }}
													cursor="pointer"
													key={`company-row-${i}`}
													onClick={() => {
														onCallback(e);
														onClose();
													}}
												>
													<Td pt="0" pb="0">
														<Image
															src={e?.logo ? c.baseFilePath + e?.logo : ''}
															w="auto"
															minW="40px"
															minH="40px"
															h="40px"
															fallbackSrc={Placeholder}
														/>
													</Td>
													<Td>{lang === 'kh' ? e?.nameKhmer : e?.name}</Td>
													<Td isNumeric>
														<CompanyBadge type={e?.type} />
													</Td>
												</Tr>
											);
										})}
									</Tbody>
									<Tfoot>
										<Tr>
											<Th>{t('Logo')}</Th>
											<Th>{t('Company Name')}</Th>
											<Th isNumeric>{t('Company Type')}</Th>
										</Tr>
									</Tfoot>
								</Table>
							</TableContainer>
							{data?.getCompaniesByCompanyTypes?.totalPages > 1 && (
								<Flex justifyContent="flex-end" w="100%" mt="4" mb={4}>
									<ReactPaginate
										previousLabel={<ChevronLeftIcon fontSize="20px" />}
										nextLabel={<ChevronRightIcon fontSize="20px" />}
										breakLabel={'...'}
										breakClassName={'break-me'}
										pageCount={data?.getCompaniesByCompanyTypes?.totalPages}
										marginPagesDisplayed={2}
										pageRangeDisplayed={3}
										onPageChange={({ selected }) => setPage((selected < 0 ? 0 : selected) + 1)}
										containerClassName={'pagination'}
										activeClassName={'active'}
										initialPage={(page - 1) | 0}
									/>
								</Flex>
							)}
						</Box>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}
